// extracted by mini-css-extract-plugin
module.exports = {"policy":"Policy_policy__1RoMj","title":"Policy_title__sRa5f","center":"Policy_center__2dghy","msg":"Policy_msg__1NBNZ","keynote":"Policy_keynote__11aRF"};